import { getEnv } from "../../../../../../utils/env"

// URLs are for PDF generation can use external

const TYPEKIT_EFFRA_STYLESHEET_URL = "https://use.typekit.net/amn1xwx.css"

const GOOGLE_FONTS_BITTER_OPEN_SANS_URL =
  "https://fonts.googleapis.com/css?family=Bitter|Open+Sans:400,700"

const FONT_AWESOME_6_STYLESHEET_URL =
  "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css"

export const getPdfGeneratorStylesheetUrls = (
  additionalUrls: string[] = []
): string[] => {
  const domain = getEnv("DOMAIN")

  const defaults = [
    `${domain}/pdf-export-doc-raptor-css/pdf-docraptor.css`,
    GOOGLE_FONTS_BITTER_OPEN_SANS_URL,
    TYPEKIT_EFFRA_STYLESHEET_URL,
    FONT_AWESOME_6_STYLESHEET_URL
  ]

  const seen = new Set(defaults)

  additionalUrls.forEach(url => {
    if (url && !seen.has(url)) {
      seen.add(url)
      defaults.push(url)
    }
  })

  return defaults
}
